import VideosEditScreen from './VideosEdit';

export default VideosEditScreen;
